import { StructuredTextDocument } from "datocms-structured-text-to-html-string";
import React from "react";
import { EventPageUiLabels } from "../../templates/event";
import Divider from "../Divider";
import RegistrationButtons from "../RegistrationButtons";
import ResponsiveContentWidthWrapper from "../ResponsiveContentWidthWrapper";
import SectionWrapper from "../SectionWrapper";
import StructuredTextGeneric from "../StructuredTextGeneric";

interface Props {
  location: Queries.EventPageQuery["datoCmsEvent"]["location"][0];
  title: Queries.EventPageQuery["datoCmsEvent"]["sectionRegistration"][0]["title"];
  description: Queries.EventPageQuery["datoCmsEvent"]["sectionRegistration"][0]["description"];
  registrationLink: Queries.EventPageQuery["datoCmsEvent"]["sectionRegistration"][0]["registrationLink"];
  additionalInformation: Queries.EventPageQuery["datoCmsEvent"]["sectionRegistration"]["0"]["additionalInformation"];
  uiLabels: EventPageUiLabels;
}

const EventPageSectionRegistration = ({
  location,
  title,
  description,
  registrationLink,
  additionalInformation,
  uiLabels,
}: Props) => {
  const data = description as unknown as StructuredTextDocument;

  return (
    <SectionWrapper noBorder>
      <ResponsiveContentWidthWrapper>
        <>
          <Divider additionalClassName="mb-16" />
          <div>
            <p className="text-2xl">{title}</p>
            <div className="mt-6">
              <StructuredTextGeneric data={data} isRegistrationDescription />
            </div>
            <RegistrationButtons
              location={location}
              registrationLink={registrationLink}
              additionalInformation={additionalInformation}
              uiLabels={uiLabels}
            />
          </div>
        </>
      </ResponsiveContentWidthWrapper>
    </SectionWrapper>
  );
};

export default EventPageSectionRegistration;
